/** Canonical email format check: local-part and domain labels forbid leading/trailing/consecutive dots and spaces. */
const EMAIL_RE = /^[a-zA-Z0-9_%+\-]+(\.[a-zA-Z0-9_%+\-]+)*@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/

export function isValidEmail(value: string): boolean {
    return EMAIL_RE.test((value || '').trim())
}

export function normalizeEmail(value: string): string {
    return (value || '').trim().toLowerCase()
}
